import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZoomComponent } from './simple-icons-zoom.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZoomComponent ],
    exports:      [ SimpleIconsZoomComponent ],
    bootstrap:    []
})
export class SimpleIconsZoomModule {}
